export class Departments {
    Id: number;
    TreeId: number;
    Name:string;
    DateOpen:Date;
    DateClose:Date;
}